import React, { useState, useRef } from "react";
import "./LoginForm.css";
import { GC_USER_ID, GC_AUTH_TOKEN } from "./constants";
import SigninMutation from "./mutations/SigninMutation";
// import { useNavigate, Link } from "react-router-dom";
import { useNavigate, Link } from "react-router-dom";
import { useThemeUpdate } from "./contexts/ThemeContext";
// import { useTheme } from "./contexts/ThemeContext";
import localForage from 'localforage';

function LoginForm(props) {
	const emailInput = useRef(null);
	const passwordInput = useRef(null);
	const [email, setEmail] = useState("");
	const [password, setPassword] = useState("");

	const [login, setLogin] = useState(false);
	// const { match, router } = useRouter();
    const navigate = useNavigate();
	const toggleTheme = useThemeUpdate();
	// const theme = useTheme();

	const isValid = () => {
		//Check client side validation here.
		return true;
	};

	let tempID = 0;

	const _saveUserData = (id, token) => {
		localStorage.setItem(GC_USER_ID, id);
		localStorage.setItem(GC_AUTH_TOKEN, token);
        localForage.setItem('auth_token_forage', token);
	};

	const [loginError, setLoginError] = useState("");

	const onSubmit = event => {
		event.preventDefault();
		let user_id = "";
		if (isValid) {
			SigninMutation(email, password, (id, token) => {
				if (token != null && email != "" && password != "") {
					_saveUserData(id, token);
					// setLogin(true);
					// createAuthDetails(id);
					user_id = id;
					// console.log("Login Successful!");
					navigate("/home");
				} else {
					setLoginError("Invalid credentials!");
				}
			});
			if (login) {
				// createAuthDetails(user_id);
			}
		}
		toggleTheme("light");
	};

	return (
		<div className="loginform-wrapper">
			<div className="signinform-container">
				<label className="login-title">Welcome back! </label>
				<form onSubmit={onSubmit} className="login-form">
					<input
						placeholder="Email"
						className="standard-textfield auth-textfield"
						name="email"
						type="text"
						ref={emailInput}
						onChange={e => {
							setEmail(e.target.value);
							setLoginError("");
						}}
					/>
					<input
						placeholder="Password"
						className="standard-textfield"
						name="password"
						type="password"
						ref={passwordInput}
						onChange={e => {
							setPassword(e.target.value);
							setLoginError("");
						}}
					/>

					{loginError.length != 0 ? (
						<div className={`message-container`}>
							<p>{loginError}</p>
						</div>
					) : null}

					<Link className="forgot-password" to="/forgot-password">
						Forgot password?
					</Link>
					<input
						className="standard-action-button"
						type="submit"
						value="Login"
					/>
					{/*

					<Link className="signup-link" to="/signup">Create Account</Link>
			*/}
				</form>
			</div>
		</div>
	);
}

export default LoginForm;
